const state = {
    currency: null,
    amount:null,
    statementId:null,
    postPaidPaymentRes:null
   
};

const getters = {
    GET_SELECTED_CURRENCY: (state) => {
        return state.currency;
    },
    GET_AMOUNT: (state) => {
        return state.amount;
    },
    GET_STATEMENT_ID: (state) => {
        return state.statementId;
    },
    GET_POST_PAID_PAY_RES: (state) => {
        return state.postPaidPaymentRes;
    },
    
};


const actions = {

    CLEAR_POSTPAID_TOPUP_STORE: ({ commit }) => {
        commit('clearPostpaidTopUpStore');
    },
    SET_POSTPAID_CURRENCY: ({ commit }, curr) => {

        commit('saveCurrency', curr);

    },
    SET_AMOUNT: ({ commit }, amt) => {

        commit('saveAmount', amt);

    },
    SET_STATEMENT_ID: ({ commit }, id) => {

        commit('saveStatementId', id);
    },

    SET_POST_PAID_PAY_RES: ({ commit }, res) => {

        commit('savePostPaidPayRes', res);

    },
    

};


const mutations = {
    clearPostpaidTopUpStore: (state) => {
        state.currency = null;
        state.amount = null;
        state.statementId=null;
        state.postPaidPaymentRes =null;
       
    },

    saveCurrency: (state, curr) => {
        state.currency = curr;
    },
    saveAmount: (state, amt) => {
        state.amount = amt;
    },
    saveStatementId: (state, id) => {
        state.statementId = id;
    },
    savePostPaidPayRes: (state, res) => {
        state.postPaidPaymentRes = res;
    },

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}